"use strict";

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      window.murmel.addToCartAndUpdate(evt);
    }
    handleErrorMessage() {
      let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && errorMessage !== false && typeof errorMessage === 'string' || errorMessage instanceof String) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}